import { PageTypes } from "@/App";
import { ModalForm, TalentechFormFieldTypes } from "@talentech/components";
import React from "react";
import * as yup from "yup";

interface IAddNewModalProps {
  isOpen: boolean;
  setIsOpen: any;
  handleSubmit: any;
  type: PageTypes;
}

const AddNewModal: React.FC<IAddNewModalProps> = (props) => {
  const modalProps = {
    title: "Add page",
    showModal: props.isOpen,
    toggleModal: () => props.setIsOpen(false),
  };

  const validationSchema = yup.object().shape({
    form: yup.object().shape({
      name: yup.string().required("Name is required"),
    }),
  });

  const formProps = {
    handleSubmit: props.handleSubmit,
    handleCancel: () => null,
    validationSchema,
    formFields: {
      section: "",
      id: "form",
      fields: [
        {
          field: "name",
          label: "Name",
          type: TalentechFormFieldTypes.TEXT,
        },
      ],
    },
  };
  return <ModalForm modal={modalProps} form={formProps} />;
};

export default AddNewModal;
